import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch, handlePostWithResult } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import PaymentMethodFormControl from '../../../../common/inputfields/PaymentMethodFormControl';

class ModifyRestrain extends Component {

    state = {
        newAgain: false,
        selectedRestrainPartner: { label: this.props.row.restrainPartnerName, value: this.props.row.restrainPartnerId },
        prevRestrainPartner: { label: this.props.row.restrainPartnerName, value: this.props.row.restrainPartnerId },
        selectedPaymentMethod: enums.outPaymentMethods.find(p => p.value === this.props.row.paymentMethod),
        selectedEmployee: { label: this.props.row.employeeName, value: this.props.row.employeeId },
        selectedSalary: { label: this.props.row.salaryYear + "-" + this.props.row.salaryMonth, value: this.props.row.salaryPrivateId },
        prevSalary: { label: this.props.row.salaryYear + "-" + this.props.row.salaryMonth, value: this.props.row.salaryPrivateId },
        amount: this.props.row.amount,
        comment: this.props.row.comment,
        errors: new Map(),
    }

    componentDidMount() {
        if (this.props.row) {
            console.log(this.props.row)
        }
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/restrain';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "amount": util.toNumber(this.state.amount),
            "comment": this.state.comment,
            "salaryId": this.state.selectedSalary.value,
            "restrainPartnerId": this.state.selectedRestrainPartner.value,
        };
        handlePatch(path, requestObject, this);
    };

    promiseSalaryOptions = async () => {
        const path = '/api/salaries';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value
        };
        const response = await axios.post(path, requestObject);
        const renamedSalaries = [];
        response.data.map((salary) =>
            renamedSalaries.push({
                label: salary.year + '-' + salary.month,
                value: salary.privateId,
            }));
        console.log(renamedSalaries);
        return renamedSalaries;
    }

    promiseRestrainPartnerOptions = async () => {
        const path = '/api/restrainpartners';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value
        };
        const response = await axios.post(path, requestObject);
        const renamedRestrainPartners = [];
        response.data.map((restrainPartner) =>
            renamedRestrainPartners.push({
                label: this.getLabelForRestrainPartner(restrainPartner.name, restrainPartner.comment),
                value: restrainPartner.privateId,
            }));
        return renamedRestrainPartners;
    }

    getLabelForRestrainPartner = (name, comment) => {
        if (comment) {
            return name + "(" + comment + ")";
        } else {
            return name;
        }
    }

    handleRestrainPartnerSelected = (e, v) => {
        if (v && v.inputValue) {
            //new restrainpartner
            const path = '/api/restrainpartner';
            const requestObject = {
                "employeeId": this.state.selectedEmployee.value,
                "name": v.inputValue
            };
            handlePostWithResult(path, requestObject, (res) => this.handleSuccessNewRestrainPartner(v, res.privateId), this);
        } else {
            this.setState({ selectedRestrainPartner: v })
        }
    }

    handleSuccessNewRestrainPartner = (v, id) => {
        let newRestrainPartner = {
            label: v.inputValue,
            value: id,
        }
        this.setState({ selectedRestrainPartner: newRestrainPartner })
        v.label = v.inputValue;
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            disabled
                            name="employee"
                            label="Munkavállaló"
                            errors={this.state.errors}
                            value={this.props.row.employeeName} />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseSalaryOptions}
                            onChange={(e, v) => this.setState({ selectedSalary: v })}
                            value={this.state.selectedSalary}
                            prevValue={this.state.prevSalary}
                            label={'Fizetés'}
                        />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseRestrainPartnerOptions}
                            onChange={this.handleRestrainPartnerSelected}
                            value={this.state.selectedRestrainPartner}
                            prevValue={this.state.prevRestrainPartner}
                            label={'Letiltás partner'}
                            createLabel={'Új letiltás partner'}
                        />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            prevValue={enums.outPaymentMethods.find(p => p.value === this.props.row.paymentMethod)}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Letiltás összege"
                            errors={this.state.errors}
                            value={this.state.amount}
                            prevValue={this.props.row.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Közlemény"
                            errors={this.state.errors}
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Mentés
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyRestrain);
